import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
  	{
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login')
    },
    {
      path: '/',
      name: 'main',
      component: () => import('@/pages/home'),
      children:[
          {
            path: '/index',
            name: 'index',
            component: () => import('@/pages/index')
          },
          {
            path: '/system/config',
            name: 'system_config',
            component: () => import('@/pages/system')
          },
          {
            path: '/system/game',
            name: 'system_game',
            component: () => import('@/pages/system/game')
          },
          {
            path: '/system/msg',
            name: 'system_msg',
            component: () => import('@/pages/system/msg')
          },
          {
            path: '/users/index',
            name: 'users_index',
            component: () => import('@/pages/users')
          },
          {
            path: '/users/agent',
            name: 'users_agent',
            component: () => import('@/pages/users/agent')
          },
          {
            path: '/users/user',
            name: 'users_user',
            component: () => import('@/pages/users/user')
          },
          {
            path: '/report/index',
            name: 'report_index',
            component: () => import('@/pages/report/index')
          },
          {
            path: '/report/user',
            name: 'report_user',
            component: () => import('@/pages/report/user')
          },
          {
            path: '/report/cate',
            name: 'report_cate',
            component: () => import('@/pages/report/cate')
          },
          {
            path: '/report/uncheck',
            name: 'report_uncheck',
            component: () => import('@/pages/report/uncheck')
          },
          {
            path: '/report/log',
            name: 'report_log',
            component: () => import('@/pages/report/log')
          },
          {
            path: '/quota/index',
            name: 'quota_index',
            component: () => import('@/pages/quota/index')
          },
          {
            path: '/quota/index/:caiid',
            name: 'quota_index',
            component: () => import('@/pages/quota/index')
          },
          {
            path: '/result/index',
            name: 'result_index',
            component: () => import('@/pages/result/index')
          },
          {
            path: '/result/index/:caiid',
            name: 'result_index',
            component: () => import('@/pages/result/index')
          },
      ],
    }
  ]
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}




// WEBPACK FOOTER //
// ./src/router/index.js